import React from 'react';
import cn from 'classnames';
import { fromJS } from 'immutable';
import { Form } from 'react-bootstrap';
import { CheckmarkAndX, AddAndCancel, FooterLabel } from './NoteInput.Buttons';
import { TextInputMention } from '../../TextInputMention/TextInputMention';
import mentionsStyles from '../../TextInputMention/mentions.module.css';

export function InputForm({
  onSubmit,
  state,
  controller,
  textAreaRef,
  loggedUser,
  handleSetNote,
  showCheckMarkButtons = false,
}) {
  const Buttons = showCheckMarkButtons ? CheckmarkAndX : AddAndCancel;
  const isTDVFooter = !showCheckMarkButtons;
  const hiddeButtons = !!handleSetNote;
  const { usersToTag, charLeft, editorState } = state.toObject();

  const onChangeText = (htmlText, inputData) => {
    if (!htmlText) return;
    if (hiddeButtons) {
      handleSetNote(fromJS({ htmlText, inputData }));
      controller.updateCharCount(inputData);
    } else controller.changeText(htmlText, inputData);
  };
  return (
    <>
      <Form
        noValidate
        className="w-100"
        onSubmit={e => {
          e.preventDefault();
          e.stopPropagation();
          onSubmit();
        }}
      >
        <span className={cn('font-size-14 text-muted', { 'd-none': isTDVFooter })}>Notes</span>
        <div className={cn('d-flex flex-column', { 'mt-3': isTDVFooter, 'mt-1': !isTDVFooter })}>
          <TextInputMention
            usersToTag={usersToTag}
            onChangeText={onChangeText}
            onFocus={() => controller.setIsEditing(true)}
            className={charLeft < 0 ? mentionsStyles.invalid : ''}
            editorState={editorState}
            setEditorState={controller.setEditorState}
            ref={textAreaRef}
            user={loggedUser}
          />
          {hiddeButtons ? <FooterLabel state={state} /> : <Buttons state={state} controller={controller} />}
        </div>
      </Form>
    </>
  );
}
